
<template>
  <div class="main">
    <Header
      :logo-white="false"
      :button="true"
      :background="true"
      :showNav="true"
    />
    <div class="flex-column flex-grid--full">
      <div 
        class="flex-column flex-grid--full align-center background"
        @click.stop.prevent="openModal(`woningKenmerk`)"
      >
        <div class="flex-column flex-grid--full align-center adres">
          <h1 v-if="adres !== ''" class="blog-white">
            <span>{{ straat }} {{ nr }} </span>
          </h1>

          <h2 v-if="adres !== ''" class="blog-white">
            <span>{{ stad }}</span>
          </h2>
          <p
            v-if="adres !== ''" 
            class="blog-white onder"
          >
            <span class="align-center">Zelfverzerkerd op de woningmarkt !</span>
          </p>
          <button
            class="btn-orange text-center"
            @click.stop.prevent="openModal('woningKenmerk')"
          >
            Meer informatie
          </button>
        </div>
      </div>
      <div class="flex-grid justify-center">
        <!-- <div class="bannerFrame">
          <a href="https://tc.tradetracker.net/?c=34975&m=2091628&a=480276&r=&u=" target="_blank" rel="noopener noreferrer">
            <img src="../isaluAssets/img/webp/wunderland.webp" alt="Wunderland brand" />
          </a>
        </div> -->

        <div class="wrapper">
          <!-- <div class="overlap">
            <span
              v-for="(Toelichting, r) in getFunnel_toelichting.stories.slice()"
              :key="r"
            >
              <span 
                v-if="Toelichting.content.Funnel == 'algemeen-koop'"
              >
                <PrimairyCTA 
                  :cta-title = Toelichting.content.partnerLinktext
                  :ctasub-title = Toelichting.content.step_header
                  :cta-link = Toelichting.content.partnerURL
                />
              </span>
              <span 
                v-if="Toelichting.content.Funnel == 'algemeen-huur'"
              >
                <PrimairyCTA 
                  :cta-title = Toelichting.content.partnerLinktext
                  :ctasub-title = Toelichting.content.step_header
                  :cta-link = Toelichting.content.partnerURL
                />
              </span>
              <span 
                v-if="Toelichting.content.Funnel == 'algemeen-leen'"
              >
                <PrimairyCTA 
                  :cta-title = Toelichting.content.partnerLinktext
                  :ctasub-title = Toelichting.content.step_header
                  :cta-link = Toelichting.content.partnerURL
                />
              </span>
            </span>
          </div> -->
      
          <!-- <h3 class="onder">
            Deze prachtige woning is te vinden in {{stad}} en is gelegen aan de {{ straat }} op nummer {{ nr }}. 
            Bent je de eigenaar van deze woning, wilt je deze woning kopen of huren of bent je gewoon nieuwsgierig? We helpen je graag zelfverzekerd op weg in de 
            huidige gekke woning 'markt'.
          </h3> -->

          <Step
            :step-as-link=true
            step-summary="kopen"
            step-title="Wat is verstandig?"
            step-detail="
              Het grootste deel van de Nederlanders koopt een woning zelf aan. Best spannend, maar er is hulp!
              Vind de juiste kennis en kies de juiste tools, want alleen dan sta je sterk. Met iSalu willen we jou gaan helpen met het maken van de juiste keuzes. 
              "
          />

          <Step
            :step-as-link=true
            step-summary="huren"
            step-title="Hoe krijg ik een voet tussen de deur?"
            step-detail="
              Het vinden van de juiste huurwoning wordt steeds lastiger. Je kunt niet meer zonder de juiste signalen op de juiste moment.
              Maar ook een makelaar kan je hier van dienst zijn. Met iSalu helpen we je op weg naar je nieuwe (t)huis. 
              "
          />
          <Step
            :step-as-link=true
            step-summary="verhuren"
            step-title="Wat besteed ik uit?"
            step-detail="
              Bij het verhuren van een woning is het belangrijk om bewust te kiezen. Alles uitbesteden...? 
              Of veel zelf doen en meer overhouden? Met iSalu kan je deze keuze maken. 
              "
          />
          <Step
            :step-as-link=true
            step-summary="verkopen"
            step-title="Wat is mijn verkoop strategie?"
            step-detail="
              Voor het verkopen van een woning wordt de lokale makelaar makkelijk gevonden, maar er zijn ook andere opties.
              Welke opties zijn er en wanneer kies je voor welke optie. Met iSalu gaan we ons best doen jou de juiste keuzes te laten maken.
              "
          />
          <Step
            :step-as-link=true
            step-summary="verbouwen"
            step-title="Waar vind de juiste mensen?"
            step-detail="
              Of je nu een woning koopt, huur of verhuurt, onderhoud blijft altijd een belangrijk onderwerp. Tegenwoordig lijkt het vinden van de 
              juiste expertise moeilijker dan de klus zelf. Met iSalu vind je de expertise die je nodig hebt.
              "
          />
          <div class="bg--grey wrapper onder">
            <h3 class="text-center">
              Op zoek naar een huurwoning? 
            </h3>
            <p class="text-center">
              Vind je nieuwe huurwoning in {{ stad }} of ergens anders in Nederland.
            </p>
            <div class="text-center">
              <a v-if="stad === 'Amsterdam'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123322&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Amsterdam</a>
              <a v-if="stad === 'Eindhoven'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123326&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Eindhoven</a>
              <a v-if="stad === 'Rotterdam'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123321&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Rotterdam</a>
              <a v-if="stad === 'Utrecht'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123323&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Utrecht</a>
              <a v-if="stad === 'Den Haag'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123324&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Den Haag</a>
              <a v-if="stad === 'Groningen'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123325&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Groningen</a>
              <a v-if="stad === 'Arnhem'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123330&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Arnhem</a>
              <a v-if="stad === 'Zwolle'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123331&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Zwolle</a>
              <a v-if="stad === 'Haarlem'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123334&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Haarlem</a>
            </div>
            <div class="text-center">
              <a class="text-center btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1128957&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow"> Huurwoning marktplaats </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <DialogModal 
      v-if="stateModal" 
      :stadJson=basicPropertyData
      :starter=starter
    />
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import Header from "@/components/ComponentHeader";
import DialogModal from "@/components/ComponentDialog";
// import PrimairyCTA from "@/components/ComponentPrimairyCTA";
import Step from "@/components/ComponentStep";
import Footer from "@/components/ComponentFooter";
import axios from 'axios';

export default {
  name: 'RegioPagina',
  components: {
    Header,
    DialogModal,
    // PrimairyCTA,
    Step,
    Footer
  },
  props: {
    stad: {
      type: String,
      required: false,
      default: ""
    },
    straat: {
      type: String,
      required: false,
      default: ""
    },
    nr: {
      type: String,
      required: false,
      default: ""
    }
  },
  data () {
    return {
      story: {
        stories: {
          content: []
        }
      },
      starter: '',
      response: {},
      backgroundImage: '',
      basicPropertyData: {},       // Om de opgehaalde data op te slaan
      loading: false,   // Om de laadstatus bij te houden
      error: null,      // Om eventuele fouten te bewaren
      propertyDetail: {},
      paramStadStraat: {}       // Om de opgehaalde data op te slaan
    }
  },
  computed: {
    ...mapGetters(["getFunnel_toelichting"]),
    ...mapState({
      stateModal: state => state.openModal,
    }),
    adres() { 
      return this.straat + " " + this.nr + " " + this.stad;
    },
    capitalizedStad() {
      return this.stad.charAt(0).toUpperCase() + this.name.slice(1);
    },
    capitalizedStraat() {
      return this.straat.charAt(0).toUpperCase() + this.name.slice(1);
    }
  },
  mounted() {
    this.waitForLCP();
  },
  methods: {
    openModal(starter) {
      this.starter = starter;
      this.$store.dispatch("toggleModal", !this.stateModal);
    },
    waitForLCP() {
      // Controleer eerst of PerformanceObserver beschikbaar is in de browser
      if ('PerformanceObserver' in window && 'largestContentfulPaint' in window.PerformanceObserver.supportedEntryTypes) {
        const observer = new PerformanceObserver((entryList) => {
          const entries = entryList.getEntries();
          // LCP bereikt, trigger Vue.js-code
          if (entries.length > 0 && entries[entries.length - 1].entryType === 'largestContentfulPaint') {
            this.executeAfterLCP();
            observer.disconnect();  // Stop met het observeren zodra LCP is bereikt
          }
        });

        // Begin met het observeren van de LCP-gebeurtenis
        observer.observe({ type: 'largest-contentful-paint', buffered: true });
      } else {
        // Als PerformanceObserver niet beschikbaar is, voer dan de code onmiddellijk uit
        this.fetchbasicData();
      }
    },
    async fetchbasicData() {
      this.loading = true; // Zet de loading status aan
      this.error = null;   // Reset eventuele eerdere fouten

      axios.defaults.headers.common['x-api-key'] = process.env.VUE_APP_GATEWAY_API;
      axios.defaults.responseType = 'json';

      const params = {
        city: this.stad.charAt(0).toUpperCase() + this.stad.slice(1),
        street: this.straat.charAt(0).toUpperCase() + this.straat.slice(1),
        number: this.nr
      };

      try {
        // Maak de API-aanroep
        const response = await axios.get('https://0ovja4ep62.execute-api.eu-west-2.amazonaws.com/' + process.env.NODE_ENV + '/orchestrateProperty', { params});
        
        // Sla de opgehaalde data op in de component state
        this.basicPropertyData = response.data['body-json'].body.Items[0];
        
      } catch (err) {
        // In geval van een fout, sla de fout op
        this.error = 'Er is een fout opgetreden bij het ophalen van de data.';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.background {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #94b0d3;
  height: 550px;
  margin-bottom: 40px;
}

.adres {
  text-transform: uppercase;
  color: #fff;
  text-transform: uppercase;
  margin-top: 5%;
}

.overlap {
  margin-top: -15%;
}

.intro {
  color: #F2F2F2;
  transform: translateY(-110%);
}

.action-blok {
  position: absolute;
  top: 22%;
  right: 20%; 
  background-color: #F2F2F2;
  padding: 25px;
  max-width: 50%;
}
.onder {
  margin-bottom: 64px;
}

.displayBox {
  padding: 2% 10%;
  margin: 64px;
}

.step__title {
  font-size: 32px;
  display: inline-block;
  margin-left: 24px;
}

.content:not(:last-child) {
  margin-bottom: 64px;
}

h4 {
  font-weight: bold;
}
.flex-grid {
  padding-bottom: 32px;
}
.bannerFrame {
  margin-top: -18%;
}

@media (min-width: 600px) and (max-width: 1023px) {

}

@media (min-width: 240px) and (max-width: 720px) {

  .background {
    height: 400px;
  }
  .adres {
    margin-top: 20%;
  }
  .action-blok {
    position: relative;
    background-color: #F2F2F2;
    padding: 40px;
  }
  .intro_box {
    position: static;
    transform: translateY(-440px);
    width: 90%;
    margin: 5%;
  }
  .content {
    margin-bottom: 20px;
  }
  .flex-grid {
    margin: 0 2%;
    padding-bottom: 32px;
  }
  .displayBox {
    padding: 2% 2%;
    margin: 64px 0;
  }
  .bannerFrame {
    margin-top: -45%;
  }
}
</style>
